import { createSlice } from '@reduxjs/toolkit';

type State = { enabled: boolean | undefined }

const initialState: State = { enabled: undefined };

const happyEnabledSlice = createSlice({
  name: 'happyEnabled',
  initialState,
  reducers: {
    updateHappyEnabled(state: State, action: { payload: boolean }) {
      state.enabled = action.payload;
    },
  },
});

export const { updateHappyEnabled } = happyEnabledSlice.actions;

export default happyEnabledSlice.reducer;
